if (!customElements.get("cart-item-subscription-actions")) {
  class CartItemSubscriptionActions extends HTMLElement {
    constructor() {
      super();
      this.select = this.querySelector("select");
      this.sellingPlanId = this.select.value;
      this.subscribeButton = this.querySelector("button");
      this.subscriptionToggle = this.querySelector(".subscription-actions-toggle");

      this.boundHandleSubscribeClick = this.handleSubscribeClick.bind(this);
      this.boundHandleSelectChange = this.handleSelectChange.bind(this);
      this.boundHandleSubscriptionToggleClick = this.handleSubscriptionToggleClick.bind(this);
    }

    connectedCallback() {
      this.select.addEventListener("change", this.boundHandleSelectChange);
      this.subscribeButton.addEventListener(
        "click",
        this.boundHandleSubscribeClick
      );
      this.subscriptionToggle.addEventListener(
        "click",
        this.boundHandleSubscribeClick
      );

      const cartDrawer = this.closest("#CartDrawer");

      if(this.dataset.recommendation == "true" && cartDrawer && cartDrawer.querySelector('ul').firstElementChild.classList.contains('subscription-item')) {
        const productCard = this.closest('.product-card');
        const defaultSellingPlan = productCard.querySelector('.cart-selling-plan-select');
        productCard.querySelector('.recommendation-selling-plan').value = defaultSellingPlan.value;
        productCard.querySelector('.product-add-to-bag-text').innerText = FoxTheme.subscriptionStrings.subscribe;
        const originalPrice = parseInt(productCard.dataset.originalPrice);
        const discount = parseFloat(defaultSellingPlan.dataset.initialDiscount);
        const discountedPrice = Math.round(originalPrice * (1 - discount / 100));
        

        productCard.querySelector('.f-price-item--regular').innerHTML = `
                  <span class="subscription-discounted-price igPrice" data-price-multiplier="0.80">${FoxTheme.Currency.formatMoney(discountedPrice, FoxTheme.settings.moneyFormat)}</span>
                  <s class="subscription-original-price igPrice">${FoxTheme.Currency.formatMoney(originalPrice, FoxTheme.settings.moneyFormat)}</s>
                `;
      }
    }

    disconnectedCallback() {
      this.select.removeEventListener("change", this.boundHandleSelectChange);
      this.subscribeButton.removeEventListener(
        "click",
        this.boundHandleSubscribeClick
      );
      this.subscriptionToggle.removeEventListener(
        "click",
        this.boundHandleSubscribeClick
      );
    }

    handleSubscriptionToggleClick() {
        this.classList.remove("no-active");
    }

    handleSelectChange(event) {

      if (this.dataset.recommendation == "true") {
        this.closest(".product-card").querySelector(".recommendation-selling-plan").value = event.target.value;
        return;
      }

      this.sellingPlanId = event.target.value;
    }

    handleSubscribeClick() {

      if (this.dataset.recommendation == "true") {
        const productCard = this.closest(".product-card");
        productCard.classList.remove("subscription-actions-toggled");
        productCard.querySelector(".recommendation-selling-plan").value = "";
        productCard.querySelector(".f-price-item--regular").innerHTML = FoxTheme.Currency.formatMoney(parseInt(productCard.dataset.originalPrice), FoxTheme.settings.moneyFormat);
        return;
      }

      this.subscribeButton.classList.add("btn--loading");
      this.subscriptionToggle.classList.add("btn--loading");

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:grouped-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const lineRef = this.dataset.lineKey
        ? { id: this.dataset.lineKey }
        : { line: this.dataset.lineIndex };

      fetch(`${FoxTheme.routes.cart_change_url}`, {
        ...FoxTheme.utils.fetchConfig(),
        ...{
          body: JSON.stringify({
            ...lineRef,
            quantity: this.dataset.qty,
            selling_plan: this.sellingPlanId,
            sections: sectionsToBundle,
          }),
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status && !data.items) {
            data.errors = data.errors || data.description || data.message;
          }
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            cart: data,
            sources: "subscription-actions",
            line: this.dataset.lineIndex,
            name: "selling_plan",
          });
        })
        .catch((error) => {
          console.error("Error updating line item selling plan -> ", error);
        });
    }
  }

  customElements.define(
    "cart-item-subscription-actions",
    CartItemSubscriptionActions
  );
}
